module.exports = {
	channel: [
		{
			value: 'email',
			label: 'Email'
		},
		{
			value: 'whatsapp',
			label: 'WhatsApp'
		},
		{
			value: 'web_upload',
			label: 'Web Upload'
		},
		{
			value: 'mobile',
			label: 'Mobile'
		}
	],
	category_selection: [
		{
			value: 'advertising_and_marketing',
			label: 'Advertising and Marketing'
		},
		{
			value: 'bank_and_finance_charges',
			label: 'Bank and Finance Charges'
		},
		{
			value: 'benefits',
			label: 'Benefits'
		},
		{
			value: 'car',
			label: 'Car'
		},
		{
			value: 'communication',
			label: 'Communication'
		},
		{
			value: 'depreciation',
			label: 'Depreciation'
		},
		{
			value: 'donations_and_charity',
			label: 'Donations and Charity'
		},
		{
			value: 'education_and_training',
			label: 'Education and Training'
		},
		{
			value: 'equipment',
			label: 'Equipment'
		},
		{
			value: 'fees',
			label: 'Fees'
		},
		{
			value: 'home_office',
			label: 'Home Office'
		},
		{
			value: 'insurance',
			label: 'Insurance'
		},
		{
			value: 'interest',
			label: 'Interest'
		},
		{
			value: 'labor',
			label: 'Labor'
		},
		{
			value: 'maintenance',
			label: 'Maintenance'
		},
		{
			value: 'materials',
			label: 'Materials'
		},
		{
			value: 'meals_and_entertainment',
			label: 'Meals and Entertainment'
		},
		{
			value: 'medical',
			label: 'Medical'
		},
		{
			value: 'office_supplies',
			label: 'Office Supplies'
		},
		{
			value: 'parking_and_tolls',
			label: 'Parking and Tolls'
		},
		{
			value: 'professional_services',
			label: 'Professional Services'
		},
		{
			value: 'rent',
			label: 'Rent'
		},
		{
			value: 'shipping_and_delivery',
			label: 'Shipping and Delivery'
		},
		{
			value: 'software_and_subscriptions',
			label: 'Software and Subscriptions'
		},
		{
			value: 'taxes',
			label: 'Taxes'
		},
		{
			value: 'travel',
			label: 'Travel'
		},
		{
			value: 'utilities',
			label: 'Utilities'
		},
		{
			value: 'other',
			label: 'Other'
		}
	],
	payment_methods: [
		{
			label: 'Alipay',
			value: 'alipay'
		},
		{
			label: 'Apple Pay',
			value: 'apple_pay'
		},
		{
			label: 'Bank Transfer',
			value: 'bank_transfer'
		},
		{
			label: 'Cash',
			value: 'cash'
		},
		{
			label: 'Cheque',
			value: 'cheque'
		},
		{
			label: 'Credit/Debit Card',
			value: 'credit_debit_card'
		},
		{
			label: 'Google Pay',
			value: 'google_pay'
		},
		{
			label: 'Octopus',
			value: 'octopus'
		},
		{
			label: 'Other',
			value: 'other'
		},
		{
			label: 'PayPal',
			value: 'paypal'
		},
		{
			label: 'Wechat Pay',
			value: 'wechat_pay'
		}
	],
	account_channel: [
		// {
		// 	value: 'email',
		// 	label: 'Email'
		// },
		{
			value: 'whatsapp',
			label: 'WhatsApp'
		}
	],
	account_status: [
		{
			value: 'verified',
			label: 'Verified'
		},
		{
			value: 'unverified',
			label: 'Unverified'
		}
	]
};
